import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import cx from 'classnames';
import DateInfo from '../../../DateInfo';
import Image from '@plone/volto/components/theme/Image/Image';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';
import PropTypes from 'prop-types';

const ImageList = ({
  items,
  isEditMode,
  hideTitles = false,
  hideDates = false,
}) => {
  return (
    <ResponsiveMasonry
      className="image-list"
      columnsCountBreakPoints={{ 320: 2, 576: 3, 768: 3, 1024: 4, 1440: 4 }}
    >
      <Masonry>
        {items.map((item) =>
          item ? (
            <ConditionalLink
              item={item}
              condition={!isEditMode}
              className="image-list-item"
              key={item['@id']}
            >
              <MaybeWrap
                condition={isEditMode}
                wrap="div"
                className="image-list-item"
                key={item['@id']}
              >
                <Image
                  item={item}
                  imageField={item.image_field}
                  alt=""
                  loading="lazy"
                  responsive={true}
                  className={'image-list-img'}
                />
                {hideTitles ? null : (
                  <div
                    className={cx('image-list-title', {
                      [`review-state-${item.review_state}`]: item.review_state,
                    })}
                  >
                    {item.title}
                  </div>
                )}
                {hideDates ? null : (
                  <DateInfo
                    properties={item}
                    hideModifiedDate
                    hidePublishedLabel
                    hideReviewState
                  />
                )}
              </MaybeWrap>
            </ConditionalLink>
          ) : null,
        )}
      </Masonry>
    </ResponsiveMasonry>
  );
};

ImageList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  isEditMode: PropTypes.bool,
  hideTitles: PropTypes.bool,
  hideDates: PropTypes.bool,
};

export default ImageList;
